export default {"src":"/_next/static/media/botanical.0b38efc5.svg","height":21,"width":31,"blurWidth":0,"blurHeight":0};